import React from 'react';

//Material
import { Box, Grid, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { connect, useDispatch } from 'react-redux';
import { StyledLabel } from '../../components/StyledComponents';
import './DeleteModal.css';
import { setIsOpenFreezePremiumModal } from '../../redux/mainReducer';
import { useNavigate } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',

  maxWidth: 900,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: '50px 80px 50px 80px',
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function FreezePremiumModal({ isOpenModal }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenFreezePremiumModal(false));
              navigate('/ua');
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="deleteModal-title-text">Преміум заморожено</StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontSize: 16,
                  fontFamily: 'FixelText-Regular',
                  textAlign: 'center',
                  maxWidth: '100%'
                }}
              >
                {
                  'Ваш преміум-статус тимчасово заморожено через невдалу оплату. Переконайтеся, що ваша платіжна інформація є актуальною та правильною. Ви можете оновити свої платіжні реквізити в розділі '
                }
                <a
                  style={{
                    textDecoration: 'underline',
                    fontFamily: 'FixelText-Regular',
                    fontSize: 16,
                    color: 'black'
                  }}
                  href={`${window.location.protocol}//${window.location.hostname}/ua/account-settings`}
                >
                  Налаштування акаунту
                </a>
                - “Керування тарифним планом” та спробувати ще раз.
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 2,
                  fontSize: 16,
                  fontFamily: 'FixelText-Regular',
                  textAlign: 'center',
                  maxWidth: '100%'
                }}
              >
                Потрібна допомога? Напишіть у
                <a
                  style={{
                    textDecoration: 'underline',
                    fontFamily: 'FixelText-Regular',
                    fontSize: 16,
                    color: 'black'
                  }}
                  href={`${window.location.protocol}//${window.location.hostname}/ua/support`}
                >
                  службу підтримки
                </a>
                .
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(FreezePremiumModal);
